// extracted by mini-css-extract-plugin
export default {"fileInput":"FileInput_fileInput__sHHlC"};